module.exports = __webpack_public_path__ + "static/media/GRADING.6c916c44.png";